<template>
  <div class="consumption-rank">
    <header class="rank-header">
      <nav aria-label="官网导航">
        <router-link to="/"><img class="logo" src="@/assets/imgs/ConsumptionRank/logo.png" alt="舞侠官网"></router-link>
        <img class="age" src="@/assets/imgs/ConsumptionRank/age.png" alt="适龄提示：16岁以上">
        <router-link to="/">官网首页</router-link>
        <router-link to="/register">快速注册</router-link>
        <router-link to="/downLoad">下载中心</router-link>
        <a :href="shopUrl" target="_blank" rel="noopener noreferrer">商城专区</a>
        <router-link to="/recharge">充值中心</router-link>
        <router-link to="/rank">游戏排行</router-link>
      </nav>
    </header>

    <main>
      <section class="rank-panel" aria-label="消费排行榜" :aria-busy="loading">
        <h1><img src="@/assets/imgs/ConsumptionRank/ranking-title.png" alt="排行榜"></h1>
        <!-- 切图自带表头和十行网格，数据区域严格对应原图 286～786px。 -->
        <table>
          <caption class="sr-only">白金币消费排行榜</caption>
          <colgroup><col class="rank-col"><col><col><col class="amount-col"></colgroup>
          <thead class="sr-only"><tr><th>排名</th><th>角色昵称</th><th>家族</th><th>消费金额</th></tr></thead>
          <tbody>
            <tr v-for="(item, index) in displayRows" :key="index">
              <td><template v-if="item"><img v-if="medals[item.rank]" class="medal" :src="medals[item.rank]" :alt="'第' + item.rank + '名'"><span v-else>{{ item.rank }}</span></template></td>
              <td :title="item ? item.usernick : ''">{{ item ? item.usernick || '—' : '' }}</td>
              <td :title="item && item.familyLoaded === false ? '家族信息暂未加载' : ''">{{ item ? item.familyName || '—' : '' }}</td>
              <td>{{ item ? formatAmount(item.consumptionAmount) : '' }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="!rows.length" class="status" role="status">
          <span>{{ loading ? '排行榜加载中…' : error || '暂无排行数据' }}</span>
          <button v-if="error && !loading" @click="fetchRank">重新加载</button>
        </div>
        <div class="update-time">{{ formatTime(info.updateTime) }}</div>
      </section>
      <div class="rank-feedback" aria-live="polite">
        <span v-if="rows.length && error">{{ error }}（当前保留上次数据） <button @click="fetchRank" :disabled="loading">重试</button></span>
        <div v-if="pageCount > 1" class="pagination">
          <button :disabled="page === 1" @click="page--">上一页</button>
          <span>{{ page }} / {{ pageCount }}</span>
          <button :disabled="page === pageCount" @click="page++">下一页</button>
        </div>
      </div>
      <section class="rules" aria-label="规则说明">
        <h2><img src="@/assets/imgs/ConsumptionRank/rules-title.png" alt="规则说明"></h2>
        <div class="rules-content">
          <div class="rule-section">
            <h3><span>01</span>消费统计</h3>
            <p class="rule-period">2026年9月23日14:00 — 10月8日24:00</p>
            <p>统计活动期间所有涉及白金币的消费，<strong>不包括主播和官方橱窗、月周卡消费</strong>。</p>
            <p>排行榜实时更新，玩家可随时查看当前排名。</p>
          </div>
          <div class="rule-section">
            <h3><span>02</span>消费榜奖励</h3>
            <div class="reward-cards">
              <div class="reward-card">
                <h4>第一名</h4>
                <p>定制歌曲 + 定制服饰 + 情侣证或动态戒指x1（二选一）+频道冠名权</p>
              </div>
              <div class="reward-card">
                <h4>第二、第三名</h4>
                <p>情侣证x1 或 动态戒指x1（二选一）</p>
              </div>
            </div>
            <p class="rule-note">可选项详见活动公告。</p>
          </div>
          <div class="rule-section">
            <h3><span>03</span>奖励发放与定制</h3>
            <p>活动结束后 <strong>7个工作日内</strong> 公告排名和奖励，实际发放奖励时间需根据实际道具更新时间决定。</p>
            <p>定制歌曲数量 = 消费金额 ÷ 200，定制服饰为一套，具体定制内容请与客服联系。</p>
          </div>
          <p class="rule-footer">本次排行数据将会在活动结束后一个月内继续展示。</p>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'
import { publicUrl } from '@/common/publicUrl'

export default {
  name: 'ConsumptionRank',
  data() {
    return {
      shopUrl: publicUrl.shopHomeUrl,
      medals: {
        1: require('@/assets/imgs/ConsumptionRank/rank-1.png'),
        2: require('@/assets/imgs/ConsumptionRank/rank-2.png'),
        3: require('@/assets/imgs/ConsumptionRank/rank-3.png')
      },
      info: {}, rows: [], page: 1, loading: false, error: '',
      refreshTimer: null, cancelRequest: null, disposed: false
    }
  },
  computed: {
    pageCount() { return Math.max(1, Math.ceil(this.rows.length / 10)) },
    displayRows() {
      const result = this.rows.slice((this.page - 1) * 10, this.page * 10)
      return result.concat(Array(10 - result.length).fill(null))
    },
    refreshLabel() {
      const seconds = Number(this.info.refreshSeconds)
      return seconds % 60 === 0 ? `${seconds / 60}分钟` : `${seconds}秒`
    }
  },
  mounted() { this.fetchRank() },
  beforeDestroy() {
    this.disposed = true
    clearTimeout(this.refreshTimer)
    if (this.cancelRequest) this.cancelRequest.cancel('页面已离开')
  },
  methods: {
    formatAmount(value) {
      return value === null || value === undefined || value === '' ? '—' : String(value)
    },
    formatTime(value) {
      if (!value || !Number.isFinite(Number(value))) return '—'
      const date = new Date(Number(value) * 1000 + 8 * 3600000)
      if (Number.isNaN(date.getTime())) return '—'
      const pad = number => String(number).padStart(2, '0')
      return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`
    },
    async fetchRank() {
      if (this.loading || this.disposed) return
      clearTimeout(this.refreshTimer)
      this.loading = true
      this.error = ''
      this.cancelRequest = axios.CancelToken.source()
      try {
        const response = await axios.post('/activity/getPlatinumConsumptionRank', {
          activityName: '2026national_midautumn_activity',
          user_id: Cookies.get('wx_userId') || ''
        }, {
          timeout: 15000, cancelToken: this.cancelRequest.token
        })
        if (this.disposed) return
        const body = response.data
        if (!body || Number(body.state) !== 200 || !body.data || !Array.isArray(body.data.rankList)) {
          throw new Error(body && body.message || '排行榜数据格式异常，请稍后重试')
        }
        this.info = body.data
        this.rows = body.data.rankList.filter(item => item && typeof item === 'object')
        this.page = Math.min(this.page, this.pageCount)
      } catch (error) {
        if (axios.isCancel(error) || this.disposed) return
        const status = error.response && error.response.status
        this.error = status === 402 || status === 401
          ? '请先在官网登录，再重新加载排行榜'
          : '排行榜加载失败，请稍后重试'
      } finally {
        if (!this.disposed) {
          this.loading = false
          this.cancelRequest = null
          const seconds = Number(this.info.refreshSeconds)
          // 失败后允许手动重试，避免未登录时反复触发全局登录提醒。
          if (!this.error) this.refreshTimer = setTimeout(this.fetchRank, Math.max(10, Number.isFinite(seconds) && seconds > 0 ? seconds : 600) * 1000)
        }
      }
    }
  }
}
</script>

<style scoped>
.consumption-rank { min-height: 100vh; padding-bottom: 260px; background: #fff1d6 url('~@/assets/imgs/ConsumptionRank/background.png') center top / 100% auto no-repeat; color: #fff; font-family: 'Microsoft YaHei', sans-serif; }
.rank-header { height: 90px; background: rgba(151, 15, 9, .9); }
.rank-header nav { max-width: 1200px; height: 100%; margin: auto; display: flex; align-items: center; justify-content: space-between; gap: 20px; }
.rank-header a { color: #fff; font-size: 23px; text-decoration: none; white-space: nowrap; }
.rank-header a:hover { text-decoration: underline; }
.rank-header .logo { width: 117px; height: 90px; object-fit: contain; }
.rank-header .age { width: 68px; height: 87px; object-fit: contain; }
main { width: min(1200px, 94%); margin: 78px auto 0; }
.rank-panel { position: relative; width: 100%; aspect-ratio: 1201 / 867; background: url('~@/assets/imgs/ConsumptionRank/ranking-panel.png') center / 100% 100% no-repeat; }
h1 { position: absolute; width: 27.48%; top: -6.57%; left: 38.2%; margin: 0; }
h1 img { width: 100%; display: block; }
table { position: absolute; top: 32.9873%; left: 0; width: 100%; height: 57.6701%; border-collapse: collapse; table-layout: fixed; font-size: clamp(12px, 1.25vw, 22px); font-weight: bold; }
.rank-col { width: 23.31%; }
.amount-col { width: 23.06%; }
tbody tr { height: 10%; }
td { padding: 0 12px; text-align: center; vertical-align: middle; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.medal { display: inline-block; width: 27px; height: 35px; object-fit: contain; vertical-align: middle; }
.update-time { position: absolute; left: 29%; top: 90.77%; height: 9.23%; display: flex; align-items: center; font-size: clamp(12px, 1.4vw, 24px); font-weight: bold; }
.status { position: absolute; top: 42%; left: 15%; width: 70%; min-height: 80px; padding: 18px; box-sizing: border-box; background: rgba(125, 22, 10, .92); border-radius: 12px; display: flex; align-items: center; justify-content: center; gap: 16px; font-size: 20px; }
button { cursor: pointer; border: 1px solid #efb575; background: #fff3db; color: #9d2b15; border-radius: 5px; padding: 7px 16px; font: inherit; }
button:disabled { opacity: .5; cursor: default; }
.rank-feedback { min-height: 40px; padding-top: 12px; color: #8b2919; text-align: center; }
.pagination { display: flex; justify-content: center; align-items: center; gap: 20px; }
.rules { margin: 66px 0 0; box-sizing: border-box; padding: 42px 56px; background: #fffdf9; border: 8px solid #ffe7d5; border-radius: 32px; box-shadow: 0 8px 32px rgba(183, 69, 31, .12); color: #60483f; }
h2 { margin: 0 0 32px; text-align: center; }
h2 img { width: 126px; height: 28px; }
.rules .rules-content { font-size: 16px; line-height: 1.9; text-align: left; }
.rules .rules-content p { margin: 8px 0; font-size: inherit; line-height: inherit; }
.rule-section + .rule-section { margin-top: 24px; padding-top: 24px; border-top: 1px solid #f3e4d9; }
.rules h3 { display: flex; align-items: center; gap: 12px; margin: 0 0 12px; font-size: 19px; font-weight: 700; color: #a73520; }
.rules h3 span { display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border-radius: 8px; background: #fff0df; color: #bd4b24; font-size: 14px; }
.rules .rule-period { color: #af3820; font-weight: 700; letter-spacing: .3px; }
.rules strong { color: #a73520; font-weight: 600; }
.reward-cards { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.reward-card { padding: 18px 22px; border: 1px solid #f1d8bf; border-radius: 12px; background: linear-gradient(120deg, #fff4e4, #fffaf3); }
.rules .reward-card h4 { margin: 0 0 6px; color: #ad3b22; font-size: 18px; font-weight: 700; }
.rules .rules-content .rule-note { font-size: 14px; color: #8b7568; }
.rules .rules-content .rule-footer { margin: 26px 0 0; padding: 14px 18px; border-radius: 8px; background: #f8f0e8; color: #80624f; font-size: 14px; }
.sr-only { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; }
@media (max-width: 900px) {
  .rank-header { height: auto; }
  .rank-header nav { padding: 6px 3%; gap: 12px; flex-wrap: wrap; justify-content: center; }
  .rank-header a { font-size: 14px; }
  .rank-header .logo { width: 65px; height: 50px; }
  .rank-header .age { width: 38px; height: 48px; }
  main { margin-top: 55px; }
  .medal { width: 18px; height: 23px; }
  td { padding: 0 4px; }
  .status { font-size: 13px; min-height: 55px; padding: 8px; }
  .rules { padding: 28px 22px; margin-top: 35px; border-width: 5px; border-radius: 24px; }
  .rules .rules-content { font-size: 15px; }
  .reward-cards { grid-template-columns: 1fr; gap: 12px; }
  .reward-card { padding: 14px 18px; }
  .consumption-rank { padding-bottom: 120px; }
}
</style>
